export enum CHART_TYPE {
    SINGLE_BAR = 'SINGLE_BAR',
    MULTI_BAR = 'MULTI_BAR',
    HORIZONTAL_BAR = 'HORIZONTAL_BAR',
    LINE = 'LINE'
  }